import PublicAuthentificationModalComponent from "./PublicAuthentificationModalComponent";

export default PublicAuthentificationModalComponent;
